import * as React from "react";
const SvgGift2D = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M9 5.66667V15.6667M9 4.83333H6.05357C5.61944 4.83333 5.20308 4.65774 4.8961 4.34518C4.58913 4.03262 4.41667 3.60869 4.41667 3.16667C4.41667 2.72464 4.58913 2.30072 4.8961 1.98816C5.20308 1.67559 5.61944 1.5 6.05357 1.5C8.34524 1.5 9 4.83333 9 4.83333ZM9 4.83333H11.9464C12.3806 4.83333 12.7969 4.65774 13.1039 4.34518C13.4109 4.03262 13.5833 3.60869 13.5833 3.16667C13.5833 2.72464 13.4109 2.30072 13.1039 1.98816C12.7969 1.67559 12.3806 1.5 11.9464 1.5C9.65476 1.5 9 4.83333 9 4.83333ZM3.16667 9H14.8333V13.8333C14.8333 14.7668 14.8333 15.2335 14.6517 15.59C14.4919 15.9036 14.2369 16.1586 13.9233 16.3183C13.5668 16.5 13.1001 16.5 12.1667 16.5H5.83333C4.89991 16.5 4.4332 16.5 4.07668 16.3183C3.76308 16.1586 3.50811 15.9036 3.34832 15.59C3.16667 15.2335 3.16667 14.7668 3.16667 13.8333V9ZM2.83333 9H15.1667C15.6334 9 15.8667 9 16.045 8.90917C16.2018 8.82928 16.3293 8.70179 16.4092 8.54499C16.5 8.36673 16.5 8.13338 16.5 7.66667V6.16667C16.5 5.69996 16.5 5.4666 16.4092 5.28834C16.3293 5.13154 16.2018 5.00406 16.045 4.92416C15.8667 4.83333 15.6334 4.83333 15.1667 4.83333H2.83333C2.36662 4.83333 2.13327 4.83333 1.95501 4.92416C1.79821 5.00406 1.67072 5.13154 1.59083 5.28834C1.5 5.4666 1.5 5.69996 1.5 6.16667V7.66667C1.5 8.13338 1.5 8.36673 1.59083 8.54499C1.67072 8.70179 1.79821 8.82928 1.95501 8.90917C2.13327 9 2.36662 9 2.83333 9Z",
      stroke: "white",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);
export default SvgGift2D;
